var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (html, showPencil, text) {pug_mixins["editButton"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan class=\"edit-step glyphicon glyphicon-pencil pull-right\" style=\"cursor: pointer;\" tabindex=\"0\"\u003E\u003C\u002Fspan\u003E";
};
if (text) {
pug_html = pug_html + ("\u003Ch3\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)));
if (showPencil) {
pug_mixins["editButton"]();
}
pug_html = pug_html + "\u003C\u002Fh3\u003E";
}
else
if (html) {
pug_html = pug_html + (null == (pug_interp = html) ? "" : pug_interp);
if (showPencil) {
pug_mixins["editButton"]();
}
}}.call(this,"html" in locals_for_with?locals_for_with.html:typeof html!=="undefined"?html:undefined,"showPencil" in locals_for_with?locals_for_with.showPencil:typeof showPencil!=="undefined"?showPencil:undefined,"text" in locals_for_with?locals_for_with.text:typeof text!=="undefined"?text:undefined));;return pug_html;};
module.exports = template;